<template>
  
  <div class="v-password">

    <input :type="type" ref="password" v-model="password" @input="emitInput()" @blur="emitBlur()">

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.17 17.13" :class="type" @click="switchView()">
      <g id="eye" data-name="Livello 1"><path class="cls-1" d="M14.88,15.73h-.16c-7-.09-11.89-6.52-12.1-6.8l-.24-.32.26-.3c4.17-4.84,8.5-7.16,12.86-6.89,6.66.41,10.91,6.67,11.09,6.93l.2.31-.23.28C23,13.45,19,15.73,14.88,15.73ZM3.67,8.64c1.08,1.28,5.46,6,11.07,6.09h.14c3.73,0,7.32-2.05,10.67-6.12-.92-1.22-4.74-5.87-10.12-6.2C11.51,2.18,7.54,4.27,3.67,8.64Z"/><path class="cls-1" d="M14.6,13.11a4.55,4.55,0,1,1,4.54-4.54A4.55,4.55,0,0,1,14.6,13.11ZM14.6,5a3.55,3.55,0,1,0,3.54,3.55A3.55,3.55,0,0,0,14.6,5Z"/></g>
      <g id="bar" data-name="Livello 2"><rect class="cls-1" x="0.74" y="7.56" width="27.72" height="2" transform="translate(-2.33 8.43) rotate(-29.94)"/><path class="cls-2" d="M25.92,1.46l.5.87L3.27,15.67l-.5-.87L25.92,1.46M26.29.1l-.87.5L2.27,13.93l-.87.5.5.87.5.87.5.86.87-.5L26.92,3.2l.87-.5-.5-.87L26.79,1,26.29.1Z"/></g>
    </svg>

  </div>

</template>

<script>
export default{

  model: {
    prop: 'passwordValue',
    event: 'input'
  },

  props: {

    passwordValue: {
      default: ''
    }

  },

  data: function(){

    return {
      password: null,
      type: 'password'
    }

  },

  methods: {

    switchView: function(){

      this.type == 'password' ? this.type = 'text' : this.type = 'password';

    },

    emitInput: function (){

      this.$emit('input', this.password);

    },

    emitBlur: function(){

      this.$emit('blur', this.password);

    }

  },

  // carica nel componente il valore se presente
  mounted: function(){

    this.password = this.passwordValue;

  }

}
</script>

<style scoped>
.v-password{
  position: relative;
  width: 100%;
}
.v-password input{
  width: 100%;
  padding: 13px 20px;
  border: 1px solid gray;
}
.v-password svg{
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  height: 20px;
  max-height: 60%;
  width: auto;
  z-index: 2;
  cursor: pointer;
}
.v-password svg .cls-1{
  fill: #828282;
} 
.v-password svg .cls-2{
  fill: #ffffff;
}
.v-password svg.text #bar{
  opacity: 0;
}
</style>
